import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import SaveButton from '@ui-elements/SaveButton';
import BasicModal from '@ui-parts/BasicModal';
import NotificationImportantRoundedIcon from '@mui/icons-material/NotificationImportantRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';

import { FONT_SIZES, PALETTE, ADMIN_PALETTE } from '~/assets/styles/base';

import { cardPayment, callThunk } from '~/api';

const FlexWrapper = styled.div`
  display: flex;
  padding: 19px 15px 29px 15px;
`;
const ModalFooterInner = styled.div`
  padding-bottom: 0px;
`;
const StyledButton = styled(SaveButton)`
  &&&.MuiButton-root.MuiButton-contained {
    font-size: ${FONT_SIZES.body3};
    color: ${PALETTE.white};
    background-color: ${ADMIN_PALETTE.primary.main};
    box-shadow: 1px 2px 2px #00000014;
    width: 148px;
    height: 40px;
    margin: 10px 0 9px 0;
  }
`;
const NotificationBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${PALETTE.text.area};
  background-color: ${PALETTE.white};
  border: 1px solid ${PALETTE.border.frame};
  padding: ${(props) => props.paddingBox || '16px 17px'};
  width: 250px;
  height: 180px;
  margin-right: ${(props) => props.marginRight || '24px'};
`;
const CreditBoxText = styled.div`
  font-size: ${FONT_SIZES.tableBody1};
  line-height: 1.6;
  white-space: pre-line;
  font-weight: 500;
  margin: ${(props) => props.margin || '0px 22px'};
  margin-top: 10px;
`;
const NotificationIcon = styled(NotificationImportantRoundedIcon)`
  color: ${PALETTE.warning.main};
  font-size: 48px;
`;
const BlockIcon = styled(BlockRoundedIcon)`
  color: ${PALETTE.warning.red};
  font-size: 48px;
`;
function CautionaryModal(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { open, handleClose, handleBody, surveyId } = props;

  const handleClickSubmit = async () => {
    await dispatch(
      callThunk({
        action: cardPayment,
        payload: surveyId,
      })
    );
    handleClose();
    handleBody();
  };

  return (
    <BasicModal
      open={open}
      titleProps={{
        title: t('invoiceRecipient.comfirmTitle'),
        fontWeight: '500',
      }}
      handleClose={() => {
        handleClose();
      }}
      buttons={[
        <ModalFooterInner key="ModalFooterInner">
          <StyledButton
            key="button1"
            handleClick={() => {
              handleClickSubmit();
            }}
            label={t('appCommon.confirm')}
          />
        </ModalFooterInner>,
      ]}
      dataTestId="CautionaryModal"
      width="880px"
      border="1px solid #c6d5dc"
    >
      <FlexWrapper>
        <NotificationBox>
          <BlockIcon />
          <CreditBoxText>{t('invoiceRecipient.warningCreditCard1')}</CreditBoxText>
        </NotificationBox>
        <NotificationBox>
          <BlockIcon />
          <CreditBoxText margin>{t('invoiceRecipient.warningCreditCard2')}</CreditBoxText>
        </NotificationBox>
        <NotificationBox marginRight paddingBox="16px 15px;">
          <NotificationIcon />
          <CreditBoxText margin>{t('invoiceRecipient.warningCreditCard3')}</CreditBoxText>
        </NotificationBox>
      </FlexWrapper>
    </BasicModal>
  );
}
CautionaryModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  handleBody: PropTypes.func,
  surveyId: PropTypes.number,
};

export default CautionaryModal;
